// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FilePlus as RawFilePlus } from "lucide-react";
export const FilePlus = /* @__PURE__ */ createIcon(RawFilePlus, "FilePlus", 2);
